import React from 'react'
import { BsFillPlayFill } from 'react-icons/bs';

const Content6 = () => {
  return (
    <div className='w-full h-auto flex flex-col justify-center items-center ml-7 ease-in-out duration-500'>
      <div className='w-full text-xl font-bold text-slate-300'>Start <span className='text-lime-500'>@Web development</span></div>
      <div className='w-full text-sm font-semibold text-slate-400 py-2'>January 2021 - present</div>
      <div className='w-full text-sm font-semibold text-slate-400 py-2 flex flex-row'> <span className='text-lime-500 mt-1 mr-2'><BsFillPlayFill /></span> I am a computer science major student . From the starting of my graduation I spent lot of time at problem solving</div>
      <div className='w-full text-sm font-semibold text-slate-400 py-2 flex flex-row'><span className='text-lime-500 mt-1 mr-2'><BsFillPlayFill /></span>I got my inerest at web development and started learning about it . I completed many small projects</div>
      <div className='w-full text-sm font-semibold text-slate-400 py-2 flex flex-row'><span className='text-lime-500 mt-1 mr-2'><BsFillPlayFill /></span>My motive is " Work hard and wait for the outcome "</div>
    </div>
  )
}

export default Content6